module.exports = __webpack_public_path__ + "static/masthead_bg_desktop_france-04fe795921422ed8009fcc4aafa5237c.jpg";